module.exports = __webpack_public_path__ + "img/logo.ca223982.png";